import { findFilenameInJUnit, loadXML } from "@split-tests/core";
import path from "path";
export default function junitAdapter(globalConfig, options) {
    const rootDir = globalConfig.rootDir;
    const junitPath = options.junit;
    const junitFile = path.resolve(junitPath.replace("<rootDir>", rootDir));
    const junit = loadXML(junitFile);
    const summary = junit.testsuites;
    return summary.testsuite.map((t) => {
        const file = findFilenameInJUnit(t);
        return {
            path: path.resolve(rootDir, file),
            time: parseFloat(t.time),
        };
    });
}
